import { IDetalleCedulaItem } from "../interfaces/ISeleccion";

// Los seis primeros son los que compara el motor (packages/core/comparar.ts).
// "sexo" y "nacionalidad" los compara cyber-service por su cuenta: el motor los
// LEE de la cédula pero no los contrasta contra la ficha (ver validarCedulaAsync).
const ETIQUETA_CAMPO: Record<string, string> = {
  run: "RUT",
  nombres: "Nombre",
  apellidoPaterno: "Apellido paterno",
  apellidoMaterno: "Apellido materno",
  fechaNacimiento: "Fecha de nacimiento",
  fechaVencimiento: "Fecha de vencimiento de la cédula",
  sexo: "Género",
  nacionalidad: "Nacionalidad",
};

/** Texto para el tooltip del badge de "requiere revisión" -- lista qué
 *  dato(s) puntual(es) no coinciden, en vez de un mensaje genérico. */
export function textoDetalleCedula(detalle?: IDetalleCedulaItem[] | null): string {
  if (!detalle || detalle.length === 0) {
    return "Revisar cédula en Ver Registro";
  }
  const campos = detalle.map((d) => ETIQUETA_CAMPO[d.campo] ?? d.campo).join(", ");
  return `No coincide: ${campos}`;
}
